// extracted by mini-css-extract-plugin
module.exports = {"header":"style__header__jDp9x","logo":"style__logo__xQ0rk","text":"style__text__dBG5B","title":"style__title__tOKXg","clientInfo":"style__clientInfo__TmdQR"};